import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FormFooter } from '../../../elements/form-footer';
import { FieldError } from "../../../elements/field-error/field-error";
import { FileInputElement } from '../../../elements/file-input';

// construccion del objeto yup de validacion del cuestionario
let obligado = {
    email: Yup.string().email('must be email').required('obligatorio'),
    first_name: Yup.string().required('obligatorio'),
    last_name: Yup.string().required('obligatorio'),
    password: Yup.string().when('password', (val) => {
        if (val) {
            return Yup.string().required().min(8, 'Min 8 characters');
        } else {
            return Yup.string().notRequired();
        }
    }),

};
const validacion = Yup.object().shape(obligado, [['password', 'password']]);

const initialValues = {
    email: '',
    first_name: '',
    last_name: ''
};

export const UsuariosForm = ({
    item,
    close,
    doDelete
}: {
    item?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {
    // console.log('USUARIOS FORM :: EDIT ITEM', item);

    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);

    // Este estado guardará la URL de la imagen subida
    const [preview, setPreview] = useState<string | null>(null);

    useEffect(() => {
        if (item) {
            setData(item);
            // Si ya hay foto en el item, podrías usarla de preview inicial:
            setPreview(item.photo_display_url || null);
        }
    }, [item]);

    // Limpia el objectURL cuando el componente se desmonte o cambie la preview
    useEffect(() => {
        return () => {
            if (preview && preview.startsWith('blob:')) {
                URL.revokeObjectURL(preview);
            }
        };
    }, [preview]);

    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);



    const beforeSubmit = (values: any | null) => {

        const after = { ...values }

        if (item) {
            delete after.companies;
            delete after.company_roles;
            delete after.groups;
            delete after.modules;
        }



        return after;
    };

    const onSubmit = async (values: any | null) => {

        const enviaremos = beforeSubmit(values);

        let formdata = new FormData();

        if (enviaremos.photo) {
            if (enviaremos.photo.photo) {
                formdata.append(
                    'photo',
                    enviaremos.photo.photo[0],
                    enviaremos.photo.photo[0].name
                );
            }
        }


        for (let key in enviaremos) {
            if (key !== 'photo') {
                formdata.append(key, enviaremos[key] ? enviaremos[key] : "");
            }
        }

        if (enviaremos.id) {
            // update
            enviaremos.username = enviaremos.email;
            api(`/fleet/users/${enviaremos.id}/`, 'PATCH', formdata, true);
        } else {
            // create
            enviaremos.username = enviaremos.email;
            api('/fleet/users/', 'POST', formdata, true);
        }

    };

    useEffect(() => {


        if (state.data) {

            if (state.path.includes('users')) {

                if (state.method === 'POST') {
                    toast.success(`${t('common.label.success-saved')}`);
                    close();

                } else if (state.method === 'GET') {

                } else if (state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    close();
                }
            }

        }

        if (state.error) {
            if (state.error.email && state.error.email[0] == 'Ya existe Usuario con este email.') {
                toast.error(`${t('common.error.already-email-exist')}`);
            }else{
                 toast.error('Server Error');
            }

        }
    }, [state]);

    return (
        <Formik
            enableReinitialize={true}
            initialValues={data || initialValues}
            validationSchema={validacion}
            validateOnBlur={true}
            onSubmit={onSubmit}
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Input
                        label={t('usuario.form.email')}
                        type="email"
                        placeholder={t('usuario.form.email')}
                        name="email"
                        value={values.email}
                        onChange={(value) =>
                            setFieldValue('email', value.email)
                        }
                    />
                    <FieldError touched={touched} errors={errors} field={"email"} />

                    <Input
                        label={t('usuario.form.first_name')}
                        type="text"
                        placeholder={t('usuario.form.first_name')}
                        name="first_name"
                        value={values.first_name}
                        onChange={(value) =>
                            setFieldValue('first_name', value.first_name)
                        }
                    />
                    <FieldError touched={touched} errors={errors} field={"first_name"} />

                    <Input
                        label={t('usuario.form.last_name')}
                        type="text"
                        placeholder={t('usuario.form.last_name')}
                        name="last_name"
                        value={values.last_name}
                        onChange={(value) =>
                            setFieldValue('last_name', value.last_name)
                        }
                    />
                    <FieldError touched={touched} errors={errors} field={"last_name"} />

                    {!item && (
                        <div>
                            <Input
                                label={t('usuario.form.password')}
                                type="text"
                                placeholder={t('usuario.form.password')}
                                name="password"
                                value={values.password}
                                onChange={(value) =>
                                    setFieldValue('password', value.password)
                                }
                            />
                            <FieldError touched={touched} errors={errors} field={"password"} />
                        </div>
                    )}

                    <div>
                        {data?.photo_display_url ? <span className="block text-sm font-semibold leading-6 text-gray-700">{t('common.form-label.foto')}</span> : ''}
                        {data?.photo_display_url ? <div className=''>
                            <img className='w-[150px] pb-4' src={data?.photo_display_url} />
                        </div> : ''
                        }
                    </div>
                    {/* PREVIEW DE LA FOTO */}
                    {!data?.photo_display_url && preview && (
                        <div className="mb-4">
                            <img className="h-[150px] object-cover rounded" src={preview} alt="Vista previa" />
                        </div>
                    )}

                    <div>
                        {/* Etiqueta opcional */}
                        <span className="block text-sm font-semibold leading-6 text-gray-700">
                            {item
                                ? preview
                                    ? t('common.label.cambiar-foto')
                                    : t('common.label.add-foto')
                                : t('common.label.add-foto')}
                        </span>

                        <FileInputElement
                            name="photo"
                            accept="image/png, image/jpeg"
                            onChange={(value: any) => {
                                // value.photo es un FileList
                                const file = value.photo?.[0];
                                setFieldValue('photo', value);
                                if (file) {
                                    // Generamos un objectURL para la vista previa
                                    const url = URL.createObjectURL(file);
                                    setPreview(url);
                                } else {
                                    setPreview(null);
                                }
                            }}
                        />
                    </div>

                    {/*  <div className='block text-sm font-semibold leading-6 text-gray-700 pb-2 pt-4'>{t('common.form-label.rol')}</div> */}

                    {/*  {roles?.map((value: any, index: number) => {
                        return <div key={index} className='pb-4'>
                            <div className='flex'>
                                <input
                                    type="checkbox"
                                    className="appearance-none checked:bg-[#223a9f] w-[20px] h-[20px]"
                                    onChange={() => handleItemCheck(value)}
                                    checked={checkRole(value)}
                                />
                                <div className='pl-4 text-[12px]'>{t(value.name)}</div>
                            </div>

                        </div>
                    })}
                    <div className='text-red-600 font-bold text-[12px] text-right mt-[-16px]'>{rolesErrorMessage}</div> */}

                    <FormFooter
                        item={item}
                        doDelete={doDelete}
                        doSubmit={handleSubmit}
                        close={close}
                    />
                </form>
            )}
        </Formik>
    );
};
